import React from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import SearchSubjects from '../../search_subjects/subjects/index'
import SearchSubjectLevels from '../../search/subject_levels'
import store from '../../../state/store'

class EditEnquiryLearnerSubject extends React.Component {

  constructor(props) {
    super(props)
    
    this.state = {
      subject_name: this.props.subject_name,
      subject_category_name: this.props.subject_category_name,
      subject_level_name: this.props.subject_level_name,
      syllabus: this.props.syllabus,
      result: this.props.result,
      focus_areas: this.props.focus_areas
    }
  }

  subject_category_name = React.createRef()
  syllabus = React.createRef()
  result = React.createRef()
  focus_areas = React.createRef()

  onChange = () => {
    this.setState({
      subject_category_name: this.subject_category_name.current.value,
      syllabus: this.syllabus.current.value,
      result: this.result.current.value,
      focus_areas: this.focus_areas.current.value
    })
  }

  onSave = () => {
    store.emit('enquiry:learner_subjects:update', this.props.enquiry_id, this.props.learner_subject_id, {
      subject_name: this.state.subject_name,
      subject_category_name: this.state.subject_category_name,
      subject_level_name: this.state.subject_level_name,
      syllabus: this.state.syllabus,
      result: this.state.result,
      focus_areas: this.state.focus_areas
    })

    this.props.onSaved()
  }

  onSubjectChange = (value) => {
    this.setState({
      subject_name: value
    })
  }

  onSubjectSelect = (subject) => {
    this.setState({
      subject_name: subject.name,
      subject_category_name: subject.subject_category_name
    })
  }

  onSubjectLevelChange = (value) => {
    this.setState({
      subject_level_name: value
    })
  }

  onSubjectLevelSelect = (subject_level) => {
    this.setState({
      subject_level_name: subject_level.name
    })
  }

  onRemove = () => {
    store.emit('enquiry:learner_subjects:destroy', this.props.enquiry_id, this.props.learner_subject_id)
  }

  render() {
    return (
      <div className="mb-2 grid gap-4 rounded-[10px] border border-border bg-card px-4 py-3">
        <div className="grid gap-2">
          <Label>Subject</Label>
          <SearchSubjects
            value={this.state.subject_name}
            country_code={this.props.country_code}
            onChange={this.onSubjectChange}
            onSelect={this.onSubjectSelect}
          />
        </div>
        <div className="grid gap-2">
          <Label>Category</Label>
          <Input placeholder="Subject Category" value={this.state.subject_category_name} ref={this.subject_category_name} onChange={this.onChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Level</Label>
          <SearchSubjectLevels
            value={this.state.subject_level_name}
            subject_category_name={this.state.subject_category_name}
            country_code={this.props.country_code}
            onChange={this.onSubjectLevelChange}
            onSelect={this.onSubjectLevelSelect}
          />
        </div>
        <div className="grid gap-2">
          <Label>Syllabus</Label>
          <Input placeholder="Syllabus" value={this.state.syllabus} ref={this.syllabus} onChange={this.onChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Result</Label>
          <Input placeholder="Result" value={this.state.result} ref={this.result} onChange={this.onChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Focus</Label>
          <Input placeholder="Areas of focus" value={this.state.focus_areas} ref={this.focus_areas} onChange={this.onChange}/>
        </div>
        <div className="flex justify-end gap-2">
          <Button size="sm" onClick={this.onSave}>Done</Button>
        </div>
      </div>
    )
  }
}

export default EditEnquiryLearnerSubject
